import "core-js/modules/es6.array.filter";

/**
 * Returns a string with truthy class names separated by space.
 *
 * @example
 * import { cx } from "reakit-utils";
 *
 * const className = cx("a", "b", false, true && "c");
 */
function cx() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.filter(Boolean).join(" ") || undefined;
}

export { cx };